var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3427 38.308H52.2502",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4528 27.364H52.2503",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5418 53.3499H9.46183C7.97683 53.3499 6.79433 52.1674 6.79433 50.6824V14.9874C6.79433 13.5024 7.97683 12.3199 9.46183 12.3199H56.5418C58.0268 12.3199 59.2093 13.5024 59.2093 14.9874V50.6824C59.2093 52.1399 58.0268 53.3499 56.5418 53.3499Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7773 35.7221C27.7085 35.7221 30.0848 32.5332 30.0848 28.5996C30.0848 24.6659 27.7085 21.4771 24.7773 21.4771C21.846 21.4771 19.4698 24.6659 19.4698 28.5996C19.4698 32.5332 21.846 35.7221 24.7773 35.7221Z",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1986 34.9522C27.1986 34.9522 28.1886 36.9047 29.6736 37.2622C31.1861 37.5922 35.5586 39.6822 36.0261 44.1647",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3028 34.9522C22.3028 34.9522 21.3128 36.9047 19.8278 37.2622C18.3153 37.5922 13.9428 39.6822 13.4753 44.1647",
    stroke: "#3eb8aa",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.c41fddc4dc96aa84a961115257121cbd.svg";
export { ForwardRef as ReactComponent };